import { GAME_ID } from '../constants/game'

const buildGameParams = ({ amount, id }) => {
  return {
    game: {
      amount: amount,
      game_id: id
    }
  }
}

const winGifs = [
  'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExZHV6YXNwZzk2bDZoeXh2b3E2Znk0aHI2eGxrcW96Y2M0cDJoZHk5ZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/IorAqDrjKiDcc3QdN3/giphy.gif',
  'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExMXd0OHo0ZmU0emJrM2Q2MDNjNWVkOGZuejZ4aDFsa3NnMm81eDNuaCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/kwcRp24Wz4lZm/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExOG0yMWJtZnE0ZzZjYjBoMjlqZm05NmRsZHR6YWRxcHo2ZnI2ZXZqcCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/CY3A9zOlZR8uhFbeok/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExMm01N3Nsa2l6YnkzM3ltNXYxdG9wNWt5cGJ1OHB4MGZlMmtiYjNlbCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/iym2NMdr3YLcI/giphy.gif',
  'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExODhnMDlrcGEwYTJ3cjMzZXZobjNxMWVrNXA0M3dpcnN1c2RxaG5wMCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Od0QRnzwRBYmDU3eEO/giphy.gif',
  'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExcGV6MHdlbzBsbHY4OHBweWV6YWprM285c25lcjNlNjdjOG11YW5veSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/GCvktC0KFy9l6/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExejE0OHZ5MDU0OGs4dmF1c2xkc2VyM3JjbmpyN3FtczE0b2l3azgzZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/XreQmk7ETCak0/giphy.gif',
  'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExZXRubzhsM2M3YTVjd2p1NHBiNzhxenF0anpxbHJkYTMxbnhtOTRndiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/amrNGnZUeWhZC/giphy.gif',
  'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExNm55dmM1djd2ZGV0eGZiemU5M2tjcWpneXZ0MXN6dTl5bGRnM3pwaiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/7ISIRaCMrgFfa/giphy.gif',
  'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExN3poM3hjYnN4bnExYWlka2twcmZ2amk1aTZzZHBrcGJra3o1eHd5MCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/RRmVIBEcGbEqlkIV2u/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExNzR4eGl6YWc4ajQ4amh5N2J0djV2aGlzbWI1dDV6cWI1MXYwcnRwaCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/wb6xgCSpLl0m4/giphy.gif',
  'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExNGM0a20wMzJmdWMxajNrNjRzZnY2cDdvdnV0b3k1d2NxNzM4a3poMyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5GoVLqeAOo6PK/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExN2QydmF4ODI1c3dnYmw5dXpoZDBtMzVtOHFtcHAzaTdxMG1pYTU1MiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/o75ajIFH0QnQC3nCeD/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExem44ZmJlYjgwYmd0dnFwejVsaTQzamdiazYzbTVkMjFtcmswdnJ0ayZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/B0vFTrb0ZGDf2/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExNW9uMnpyb3NldGE4NnRhbDc5MW5xcWRtMWc4ejh6cDJ2cTBzOTI1ZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xSM46ernAUN3y/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZHUyd211NWp6ZzF3eW1tcWs3bGU0YTl1ejhzeGt6YmY4b2J5enNvOSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/MNmyTin5qt5LSXirxd/giphy.gif',
  'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExMm14M3R4b3Z0cG50b25hcjRtMGN4aXltbWNvZWY5MThldGQwaDNvbCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/hXDrTueJWAscK3xWQ2/giphy.gif',
  'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExMmMyeDJtazFwaWdmZXViNHQ2aTkxemY2Z2g3Z2E5NnZnMHVzanY4cSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/DffShiJ47fPqM/giphy.gif',
  'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExYnpnYzVtc2YyZWhvazExMnZvN2h2cXJvdmJtOWV0ZGs4NTA2OHFhMyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o7aDfEAl370Fbgu40/giphy.gif',
  'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExcDhtbDd2d3duNnpyZnQ4c21yMWwzcWcyZXU1bnYyZHV0Y3FtMXFxbSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/kRXnZwKrPTwVq/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExazliczBqdzJjZTc0Ymo5bTF3MWFrc29rNHpidDFtZDAwam1mOWx5dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/dMsh6gRYJDymXSIatd/giphy.gif',
  'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZGJzYnVldTZnMHhmZnYwMHcxMjM2NXk3dTg3Nnl3aG5hcWtvYzQ0eiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/cdNSp4L5vCU7aQrYnV/giphy.gif',
  'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExandiaW15ZW14OXBhbWx3bWh2a3NkMGt5YnFzdmltb2FjOWk2NnRoeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/qlrBlSDevEdFeW5JwV/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExcDllemk1c2Vld3B3NjlldjViNWRmcjV0d2hpbmY5NXlyM2VvMzV4eCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/xT0GqssRweIhlz209i/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExYjRjcmd6bmhtbWh0YXl3Y3I2dnZod3NwZWo3MXgzNjJmNjc2aWJwaCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/uudzUtVcsLAoo/giphy.gif',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExcmI4em01MHdtNzUyZHl5MWtuMGZwMWtmM3UwYmJmZWhzcjVzM2ZueCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3ohzdIuqJoo8QdKlnW/giphy.gif',
  'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExODhocjk3Y3k5dWQycWxqdzhjMHV5aTl3bmRma3dndG9kYWk5dTgxayZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/dkGhBWE3SyzXW/giphy.gif',
  'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExc3Q1c3RudnpzbDU2Zm9vYjBvZ2trcHMzZG8yOHB4MXlzOHp2ZHdpZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/GRSnxyhJnPsaQy9YLn/giphy.gif'
]

const getRandomGif = () => {
  return winGifs[Math.floor(Math.random() * winGifs.length)]
}

const COINS_VALUES_DATA = [
  { count: 5, value: 150000 },
  { count: 4, value: 25000 },
  { count: 3, value: 250 },
  { count: 2, value: 25 },
  { count: 1, value: 5 },
  { count: 0, value: 2 }
]

const getCoinsValues = () => {
  return COINS_VALUES_DATA.sort((a, b) => b.value - a.value)
}

const getMaxRewardValue = () => {
  return getCoinsValues().at(0)
}

const getCountByValue = (value) => {
  for (let i = 0; i < COINS_VALUES_DATA.length; i++) {
    if (value >= COINS_VALUES_DATA[i].value) {
      return COINS_VALUES_DATA[i].count
    }
  }
  return 0
}

const triggeredByGameRandomValue = () => {
  return `game ${GAME_ID.RANDOM_VALUE}`
}

const buildSleapUrl = (authId) => {
  return `https://sleap.io/?partner=qiibee&qbx_auth_id=${authId}`
}
export {
  buildGameParams,
  getRandomGif,
  getCoinsValues,
  getCountByValue,
  getMaxRewardValue,
  triggeredByGameRandomValue,
  buildSleapUrl
}
